export default __webpack_public_path__ + "static/12.09-e36291fe75d763c2667afddd6d773c72.png";